/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {batchCreateOrUpdateActivityItem} from '../api'

export const useMutationBatchCreateOrUpdateActivityItem = createReactQueryMutationHook('batchCreateOrUpdateActivityItem', batchCreateOrUpdateActivityItem)
